<div class="contentContainer">
  <div *ngIf="userKind == 'ProviderUser'">
    <app-user-setup-provider></app-user-setup-provider>
  </div>
  <div *ngIf="userKind != 'ProviderUser'">
    <app-user-setup-admin></app-user-setup-admin>
  </div>
</div>
